import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { MediaGalleryStoryblok } from "~/generated/sb/blok-types";
import { sizes } from "~/lib/utils/sizes";
import styles from "./MediaGalleryBlok.module.css";

export const MediaGalleryBlok = ({ blok, preview }: BlokProps<MediaGalleryStoryblok>) => {
	return (
		<BlokWrap className={styles.root} editable={blok}>
			<p className={styles.tag}>{blok.tag}</p>
			<h2 className={styles.title}>{blok.title}</h2>
			<div className={clsx(styles.cards, "scroll_container")} data-mobile-only>
				{blok.media?.map((media) => (
					<div className={styles.card__wrapper} key={media?._uid}>
						<div className={styles.card}>
							<StoryblokComponent blok={media} sizes={sizes(95, 33)} preview={preview} />
						</div>
					</div>
				))}
			</div>
		</BlokWrap>
	);
};
